/**
 * Share Import Plugin
 * Capacitor plugin for iOS Share Extension integration
 */

import { registerPlugin } from '@capacitor/core';

const ShareImportPlugin = registerPlugin('ShareImportPlugin');

export default ShareImportPlugin;
